export function humanizeEnum(value) {
  if (!value) return '';
  return String(value)
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function truncate(text, max = 60) {
  if (!text) return '';
  const s = String(text);
  return s.length <= max ? s : `${s.slice(0, max - 1)}…`;
}

export function bytesToKb(bytes) {
  if (!bytes && bytes !== 0) return 0;
  return Math.max(1, Math.round(bytes / 1024));
}

export function joinName(first, middle, last) {
  return [first, middle, last].filter(Boolean).join(' ');
}
